import http from '@/utils/http';
const call=async(action,data)=>{const response=await http({url:'/api/admin/v1/contractProjectOrderDisposition/'+action,data,method:'post'});if(response?.code!==0)throw Error(response?.msg||'处置请求失败');return response.data;};
export default Object.fromEntries(['detail','execute','confirm','reject'].map(action=>[action,data=>call(action,data)]));
